export const categoriziationCategoryKeys = {
  all: ["categorizationCategory"] as const,
  project: (projectId: string | null) => [...categoriziationCategoryKeys.all, projectId] as const,
};
